/**
 * Eligibility worklist action indicators matching the table design.
 */

import { Bell, Bookmark } from "lucide-react";

/** Data rendered in the eligibility Action Items cell. */
export interface EligibilityActionItemsValue {
  mrn: string;
  isBookmarked: boolean;
  notificationUnreadCount: number;
  hasUnreadNotification: boolean;
  onOpenNotifications?: () => void;
  onToggleBookmark?: () => void;
}

/** Props for the eligibility action-items renderer. */
interface EligibilityActionItemsCellProps {
  value: EligibilityActionItemsValue;
}

/**
 * Render user-specific bookmark and Notes notification actions for an eligibility row.
 *
 * @param props - Bookmark and Notes notification metadata for one patient
 * @returns Action item icons with accessible status descriptions
 */
export function EligibilityActionItemsCell({
  value,
}: EligibilityActionItemsCellProps) {
  return (
    <div
      className="flex items-center gap-2 text-[#0056D6]"
      onClick={(event) => event.stopPropagation()}
    >
      <button
        type="button"
        className="rounded border-0 bg-transparent p-0 text-[#0056D6] hover:scale-105"
        aria-label={`${value.isBookmarked ? "Remove" : "Add"} bookmark for MRN ${value.mrn}`}
        aria-pressed={value.isBookmarked}
        onClick={value.onToggleBookmark}
      >
        <Bookmark
          size={16}
          fill={value.isBookmarked ? "currentColor" : "none"}
          strokeWidth={value.isBookmarked ? 2.5 : 1.75}
        />
      </button>
      <button
        type="button"
        className="rounded border-0 bg-transparent p-0 text-[#0056D6] hover:scale-105"
        aria-label={`${value.notificationUnreadCount ?? 0} unread Notes notifications for MRN ${value.mrn}`}
        onClick={value.onOpenNotifications}
      >
        <Bell
          size={16}
          fill={value.hasUnreadNotification ? "currentColor" : "none"}
          strokeWidth={value.hasUnreadNotification ? 2.5 : 1.75}
        />
      </button>
    </div>
  );
}

export default EligibilityActionItemsCell;
